export const AD_SLOT_BOARD_DETAIL_SIDEBAR = 'board-detail-sidebar';
export const AD_SLOT_PROJECT_BUILDER_BANNER = 'project-builder-banner';

export const AD_SLOT_DEFINITIONS = [
  {
    key: AD_SLOT_BOARD_DETAIL_SIDEBAR,
    title: 'Board Details Sidebar',
    description: 'Shown in the right sidebar on board detail pages.',
    recommendedSize: 'Recommended: tall image around 300x600 or 320x480.',
  },
  {
    key: AD_SLOT_PROJECT_BUILDER_BANNER,
    title: 'Project Builder Banner',
    description: 'Shown above the Project Builder workspace.',
    recommendedSize: 'Recommended: wide banner around 1200x180 or 1600x220.',
  },
];

export const AD_SLOT_DEFINITION_MAP = Object.fromEntries(
  AD_SLOT_DEFINITIONS.map((slot) => [slot.key, slot])
);

const normalizeBooleanValue = (value) => {
  if (value === true || value === 1 || value === '1') {
    return true;
  }

  if (typeof value === 'string') {
    return ['true', 'yes', 'on'].includes(value.trim().toLowerCase());
  }

  return false;
};

export const normalizeAdRecord = (value, fallbackSlotKey = '') => {
  const slotKey = String(value?.slot_key ?? value?.slotKey ?? fallbackSlotKey).trim();
  const slotDefinition = AD_SLOT_DEFINITION_MAP[slotKey] || null;

  return {
    slot_key: slotKey,
    title: String(value?.title ?? slotDefinition?.title ?? slotKey).trim(),
    description: String(value?.description ?? slotDefinition?.description ?? '').trim(),
    recommended_size: String(value?.recommended_size ?? value?.recommendedSize ?? slotDefinition?.recommendedSize ?? '').trim(),
    image_url: String(value?.image_url ?? value?.imageUrl ?? '').trim(),
    click_url: String(value?.click_url ?? value?.clickUrl ?? '').trim(),
    alt_text: String(value?.alt_text ?? value?.altText ?? '').trim(),
    is_active: normalizeBooleanValue(value?.is_active ?? value?.isActive),
    updated_at: value?.updated_at ?? value?.updatedAt ?? null,
  };
};

export const normalizeAdCollection = (value) => {
  const records = Array.isArray(value) ? value : [];
  const recordsBySlot = new Map();

  records.forEach((record) => {
    const normalizedRecord = normalizeAdRecord(record);

    if (!normalizedRecord.slot_key) {
      return;
    }

    recordsBySlot.set(normalizedRecord.slot_key, normalizedRecord);
  });

  return AD_SLOT_DEFINITIONS.map((slotDefinition) => (
    recordsBySlot.get(slotDefinition.key) || normalizeAdRecord({}, slotDefinition.key)
  ));
};

export const findAdRecordBySlot = (records, slotKey) => (
  (Array.isArray(records) ? records : [])
    .map((record) => normalizeAdRecord(record))
    .find((record) => record.slot_key === slotKey) || null
);
